import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { FormErrorMessage, Text } from '@chakra-ui/core'
import { StyledFormControl, StyledFormLabel } from 'components/AdminConsole/commonUI/styles'
import useLocaleText from 'components/useLocaleText'
import { ALargeSmall } from 'lucide-react'
import { InputWithIcon } from 'components/AdminConsole/commonUI/InputWithIcon'
import { getNestedError, MAX_PUSH_TITLE_LENGTH } from '../utils'

interface PushTitleFieldProps {
  keyName: string
  label: string
  placeholder: string
  keySwitch: string
}

export const PushTitleField = ({
  keyName = 'data.push_title',
  label = 'push_title',
  placeholder = 'push_title_placeholder',
  keySwitch = 'is_send_push_notification',
}: PushTitleFieldProps) => {
  const { register, errors, watch, clearError } = useFormContext()
  const isSendPushNotification = watch(keySwitch) as boolean
  const t = useLocaleText(label, true) as string
  const t_placeholder = useLocaleText(placeholder, true) as string
  const error_push_title = useLocaleText('error_push_title', true) as string
  const error_push_title_max_length = useLocaleText('error_push_title_max_length', true)

  const error = getNestedError(errors, keyName)

  const validationRules = {
    required: isSendPushNotification ? error_push_title : false,
    maxLength: {
      value: MAX_PUSH_TITLE_LENGTH,
      message: error_push_title_max_length,
    },
  }

  useEffect(() => {
    if (!isSendPushNotification) {
      clearError(keyName)
    }
  }, [clearError, isSendPushNotification, keyName])

  return (
    <StyledFormControl
      isInvalid={!!error}
      pointerEvents={isSendPushNotification ? 'auto' : 'none'}
      opacity={isSendPushNotification ? 1 : 0.5}
    >
      <StyledFormLabel required={isSendPushNotification}>
        <ALargeSmall size={18} strokeWidth={2.5} />
        <Text>{t}</Text>
      </StyledFormLabel>
      <InputWithIcon name={keyName} ref={register(validationRules)} placeholder={t_placeholder} />
      <FormErrorMessage>{error?.message}</FormErrorMessage>
    </StyledFormControl>
  )
}
